import { schema } from "normalizr";
import { ChatMessage as ChatMessageRecord } from "records/chat-message";
import { List } from "immutable";

export const ChatMessage = new schema.Entity(
    "chatMessages",
    {},
    {
        idAttribute: (data) => {
            return data.key;
        },
        processStrategy: (data) => {
            return {
                key: data.key,
                messages: List(data.messages),
            };
        },
    }
);

(ChatMessage as any).record = ChatMessageRecord;
